import m from 'mithril'
import {t} from 'store'
import {Modal, ModalOverlay, ModalStore, Portal} from '@codeurs/front'
import Layout from 'views/layout'
import Button from 'views/layout/button'
import Container from 'views/layout/container'
import Title from 'views/layout/title'
import Wysiwyg from 'views/layout/wysiwyg'
import Share from 'views/partials/share'
import Popup from 'views/popup/popup'

const text =
	'<h2>Heading 2</h2><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>'
const popupDesc =
	'<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>'

export default class Page extends Layout {
	popupModal = new ModalStore()

	view() {
		return m('.page', [
			m(Container, [
				m(Title, {heading: 1}, 'title'),
				m(Wysiwyg, {html: text}),
				m(Button, {onclick: this.popupModal.open}, t('open')),
				m(Share, {text: t('share')})
			]),
			this.viewPopup()
		])
	}

	viewPopup() {
		return m(Portal, [
			m(Modal, this.popupModal, [
				m(ModalOverlay),
				m(Popup, {desc: popupDesc, ...this.popupModal})
			])
		])
	}
}
